<main class="main main-with-bg" role="main" id="main" tabindex="-1">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="text-center">
                    <h1>{{ 'pageInMaintenance.title' | translate }}</h1>
                    <p class="lead m-0">{{ 'pageInMaintenance.subtitle' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</main>
